const attrsReuseMap = {}
class ReuseMap {
  constructor () {
    this.attrsReuseMap = {}
  }
  addReuseMap(shape, attrs) {
    this.attrsReuseMap[shape] = attrs
  }
  deleteReuseMap(shape) {
    attrsReuseMap[shape] = null
  }
  getReuseMap(shape) {
    return this.attrsReuseMap[shape]
  }
  clear() {
    this.attrsReuseMap = null
  }
}

export default new ReuseMap()